<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapse = !collapse"
  >
    <div class="col-4">
      <h3>Professional Liabilities</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{ collapse ? 'up' : 'down' }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (complianceSettingForms) {
    <div class="inner-panel rounded" [(ngbCollapse)]="collapse">
      @if (!collapse) {
        <div class="row align-items-center mx-2">
          <div class="col">
            <div class="row">
              <div class="col-3"></div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3 d-flex flex-column">
                  <label class="form-label align-self-center">{{
                    form && form.controls.riskLevel.value === 0
                      ? 'Global'
                      : 'Risk Level ' + form.controls.riskLevel.value
                  }}</label>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Policy Required?</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-check-group mt-0">
                      <input
                        id="professionalLiability_policyRequired{{
                          form.controls.id.value
                        }}"
                        type="checkbox"
                        class="form-check-input"
                        (change)="onProfessionalLiabilityIsRequiredChange()"
                        formControlName="errorsAndOmissions_isRequired"
                      />
                      <label
                        for="professionalLiability_policyRequired{{
                          form.controls.id.value
                        }}"
                        class="form-check-label"
                        >Required?</label
                      >
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">A.M. Best Rating</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <select
                        class="form-select"
                        formControlName="errorsAndOmissions_amBestRating"
                      >
                        @for (
                          item of amBestValueMap
                            | keyvalue: keyValuePairDefaultOrder;
                          track item
                        ) {
                          <option [ngValue]="item.value">
                            {{ item.key }}
                          </option>
                        }
                      </select>
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label"
                  >Waive Non-Rated A.M. Best Rating Carriers?</label
                >
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-check-group">
                      <input
                        id="pl_AllowNRRatedAMBestCarriers{{
                          form.controls.id.value
                        }}"
                        type="checkbox"
                        class="form-check-input"
                        formControlName="pl_AllowNRRatedAMBestCarriers"
                      />
                      <label
                        for="pl_AllowNRRatedAMBestCarriers{{
                          form.controls.id.value
                        }}"
                        class="form-check-label"
                        >Waive</label
                      >
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">A.M. Best Financial Size</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <select
                        class="form-select"
                        formControlName="errorsAndOmissions_financialSizeCategory"
                      >
                        @for (
                          item of amBestFinancialValueMap
                            | keyvalue: keyValuePairDefaultOrder;
                          track item
                        ) {
                          <option [ngValue]="item.value.value">
                            {{ item.key }}
                          </option>
                        }
                      </select>
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Each Occurrence</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Amount"
                          [inputMask]="currencyMask"
                          (ngModelChange)="
                            applyCurrencyFormat(
                              form.controls['errorsAndOmissions_policyAmount'],
                              $event
                            )
                          "
                          [formControl]="
                            form.controls['errorsAndOmissions_policyAmount']
                          "
                        />
                      </div>
                    </div>
                  </form>
                </div>
              }
            </div>
            @for (
              item of checkBoxFields | keyvalue: keyValuePairDefaultOrder;
              track item
            ) {
              @if (item.value.show) {
                <div class="row py-2">
                  <div class="col-3">
                    <label class="form-label">{{ item.key }}</label>
                  </div>
                  @for (form of complianceSettingForms; track form) {
                    <div class="col-3">
                      <form [formGroup]="form">
                        <div class="form-check-group">
                          <input
                            id="{{ item.key + '_' + form.controls.id.value }}"
                            type="checkbox"
                            class="form-check-input"
                            formControlName="{{ item.value.controlName }}"
                          />
                          <label
                            for="{{ item.key + '_' + form.controls.id.value }}"
                            class="form-check-label"
                            >Required?</label
                          >
                        </div>
                      </form>
                    </div>
                  }
                </div>
              }
            }
          </div>
          <!-- <div class="col-3">
                  <div class="row"></div>
                  <div *ngFor="let item of professionalLiabilityMap | keyvalue: keyValuePairDefaultOrder" class="row pt-1">
                    <div class="col">
                      <label class="form-label">{{ item.key }}</label>
                    </div>
                  </div>
                </div>
                <ng-container *ngFor="let form of complianceSettingForms; let first = first">
                  <form [formGroup]="form" class="col-3">
                    <div class="row">
                      <div class="col d-flex flex-column align-items-center">
                        <label class="text-center">{{ form.controls.riskLevel.value === 0 ? 'Global' : ('Risk Level ' + form.controls.riskLevel.value) }}</label>
                      </div>
                    </div>
                    <ng-container *ngFor="let item of professionalLiabilityMap | keyvalue: keyValuePairDefaultOrder">
                      <div class="row align-items-center justify-content-center py-1">
                        <div class="col">
                          <div *ngIf="item.value.inputType === 'Select'" class="form-group">
                            <select class="form-select" formControlName="{{ item.value.controlName }}">
                              <option *ngFor="let option of item.value.selectOptions | keyvalue: keyValuePairDefaultOrder" [ngValue]="getOptionValue(option)">{{ option.key }}</option>
                            </select>
                          </div>
                          <div *ngIf="item.value.inputType === 'Checkbox'" class="form-check-group mt-0">
                            <input id="professionalLiability_{{ item.value.controlName + '_' + form.controls.id.value }}" type="checkbox" class="form-check-input" formControlName="{{ item.value.controlName }}">
                            <label for="professionalLiability_{{ item.value.controlName + '_' + form.controls.id.value }}" class="form-check-label">{{ item.value.checkBoxLabel }}</label>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </form>
                </ng-container> -->
        </div>
      }
    </div>
  }
</app-display-card>
